import { authenticatedApi, cookieDomain, getAccessToken, request, setAccessToken, tokenName, unauthenticatedApi } from "./dataProvider";
import Cookies from "js-cookie";

export default {
    // called when the user attempts to log in
    login: ({ username, password }) => {
        // return Promise.resolve();
        return new Promise((resolve, reject) => {
            unauthenticatedApi.post('/token/request', {
                email: username,
                password: password,
                token_name: 'portal',
            }).then(response => {
                setAccessToken(response.data.access_token);

                // don't allow unauthorized users to login
                const perms = response.data.user.permissions;
                if(!perms.msa && !perms.staff && !perms.cp) {
                    reject();
                    return;
                }

                // localStorage.setItem('username', username);
                localStorage.setItem('perms', JSON.stringify(response.data.user.permissions));
                // setUser(response.data.user)

                // give the access token a chance to update
                // setTimeout(() => {
                    resolve();
                // }, 50);
            }).catch(e => {
                reject();
            });
        })


        let p = new Promise(function(resolve,reject){
            unauthenticatedApi('sanctum/csrf-cookie')
            .then(response => {
                unauthenticatedApi.post('/login', {
                    email: username,
                    password: password
                }).then(response => {
                    resolve();
                }).catch(response => {
                    reject();
                })
            }).catch(response => {
                reject();
            });
        });

        return p.then(() => {
            localStorage.setItem('username', username);
            return Promise.resolve();
        }).catch(() => {
            return Promise.reject();
        });
    },
    // called when the user clicks on the logout button
    logout: () => {
        return new Promise((resolve, reject) => {
            localStorage.removeItem('perms');
            // localStorage.removeItem('username');
            Cookies.remove(tokenName, {
                domain: cookieDomain,
            });
            authenticatedApi.get('/revoke-token');

            // setUser(null);

            resolve();
        });

        return Promise.reject();
        let p = new Promise(function(resolve,reject){
            authenticatedApi('logout', {
                method: 'POST'
            }).then((response) => {
                if (response.status === 204) {
                    resolve();
                }
            }).catch(({ response }) => {
                return reject();
            })
        });

        return p.then(() => {
            localStorage.removeItem('username');
            return Promise.resolve();
        }).catch(() => {
            return "login";
        });
    },
    // called when the API returns an error
    checkError: (response/*{ response }*/) => {
        if (typeof response !== 'undefined' && (response.status === 401 || response.status === 403)) {
            // localStorage.removeItem('username');
            Cookies.remove(tokenName, {
                domain: cookieDomain,
            });
            return Promise.reject();
        }
        return Promise.resolve();
    },
    // called when the user navigates to a new location, to check for authentication
    checkAuth: () => {
        return new Promise((resolve, reject) => {
            if(!Cookies.get(tokenName)) {
                reject();
                return;
            }

            let cachedPerms = localStorage.getItem('perms');
            if(cachedPerms) {
                try {
                    if(typeof cachedPerms === 'string') {
                        cachedPerms = JSON.parse(cachedPerms);
                    }
                    // don't allow unauthorized users to login
                    if(!cachedPerms.msa && !cachedPerms.staff && !cachedPerms.cp) {
                        reject();
                        return;
                    }
                } catch(e) {}

                resolve();
                return;
            }

            reject();
        });
    },
    // called when the user navigates to a new location, to check for permissions / roles
    getPermissions: () => {
        return new Promise((resolve, reject) => {
            /*
            let cachedPerms = localStorage.getItem('perms');
            if(cachedPerms) {
                if(typeof cachedPerms === 'string') {
                    try {
                        cachedPerms = JSON.parse(cachedPerms);
                        resolve(cachedPerms);
                        return;
                    } catch(e) {}
                } else {
                    resolve(cachedPerms); // todo: more typechecking
                    return;
                }
            }
            */
            return authenticatedApi.get('/users/me').then(response => {
                localStorage.setItem('perms', JSON.stringify(response.data.permissions));
                resolve(response.data.permissions);
            }).catch(response => {
                reject(response.data);
            });
        })
    },

    getIdentity: () => {
        return new Promise((resolve, reject) => {
            return authenticatedApi.get('/users/me').then(response => {
                localStorage.setItem('perms', JSON.stringify(response.data.permissions));
                resolve(response.data);
            }).catch(response => {
                reject(response.data);
            });
        })
    }

};
